<template>
  <div class="dashboard-panel">
    <h3 class="section-title mb-4">
      <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
      </svg>
      Portfolio Status
    </h3>
    <v-chart class="w-full h-64" :option="chartOption" autoresize />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import { LegendComponent, TooltipComponent } from 'echarts/components'
import VChart from 'vue-echarts'

use([CanvasRenderer, PieChart, LegendComponent, TooltipComponent])

const props = defineProps({
  onTrack: { type: Number, default: 0 },
  atRisk: { type: Number, default: 0 },
  delayed: { type: Number, default: 0 }
})

const chartOption = computed(() => ({
  tooltip: { trigger: 'item' },
  legend: {
    orient: 'vertical',
    right: 10,
    top: 'center'
  },
  series: [{
    name: 'Status',
    type: 'pie',
    radius: ['42%', '68%'],
    center: ['40%', '50%'],
    avoidLabelOverlap: false,
    itemStyle: {
      borderRadius: 8,
      borderColor: '#fff',
      borderWidth: 3
    },
    label: {
      show: true,
      position: 'outside',
      formatter: '{b}\n{c}',
      color: '#475569',
      fontSize: 12,
      fontWeight: 500
    },
    labelLine: {
      lineStyle: { color: '#cbd5e1' }
    },
    data: [
      { value: props.onTrack, name: 'On Track', itemStyle: { color: '#10b981' } },
      { value: props.atRisk, name: 'At Risk', itemStyle: { color: '#f59e0b' } },
      { value: props.delayed, name: 'Delayed', itemStyle: { color: '#ef4444' } }
    ]
  }]
}))
</script>
